import { z } from "zod";

import { availabilitySchema } from "../commons";

export const dashboardResponseSchema = z.object({
  availability: availabilitySchema,
  totalHighlights: z.number(),
  totalEarnings: z.number(),
});

export type DashboardResponse = z.infer<typeof dashboardResponseSchema>;
